import React, { createContext, useState, useEffect } from "react";

// Create the UserContext
export const UserContext = createContext();

// Create a provider component
export const UserProvider = ({ children }) => {
    // Get the username from localStorage if available
    const storedUsername = localStorage.getItem("username") || "";

    const [username, setUsername] = useState(storedUsername);

    // Keep localStorage in sync (including clear on logout / empty username)
    useEffect(() => {
        if (username) {
            localStorage.setItem("username", username);
        } else {
            localStorage.removeItem("username");
        }
    }, [username]);

    return (
        <UserContext.Provider value={{ username, setUsername }}>
            {children}
        </UserContext.Provider>
    );
};
